import { TFunction } from 'i18next';

export const language = localStorage.getItem('lang') ?? 'en';
export const statusNameById = (
  t: (key: string) => string,
  statusId?: number,
  isMobileClinic?: boolean,
  isConsultation?: boolean,
  appointmentMissed?: boolean
): string => {
  if (appointmentMissed) return t('missed');
  if (statusId === 1) return t(isMobileClinic && isConsultation ? 'prepare' : 'pending');
  if (statusId === 2) return t('closed');
  if (statusId === 3) return t('void');
  if (statusId === 4) return t('parked');
  if (statusId === 5) return t('prepared');
  if (statusId === 6) return t('started');
  return t('open');
};
